import styled from 'styled-components';

export const SyncSection = styled.div`
  width: 100%;
  background: ${({ theme, $background }) => $background || 'transparend'};
`;

export const SyncSectionData = styled.div`
  width: 100%;
  padding: 0.75rem;
  gap: 0.5rem;
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: space-between;
`;

export const SyncList = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: space-between;
`
